import { type IntegrationPipedriveCampaignCheckboxes } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationPipedriveSettings/types'

export const PIPEDRIVE_SYNC_CHECKBOX_KEYS: IntegrationPipedriveCampaignCheckboxes[] = [
  'sync_save',
  'sync_update',
]
